import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { TwcPopupService } from '@topcon/twc-angular';

import { TranslationService, UiConfigurationLanguageGroup, UiConfigurationService } from '@mirage-projects/cw-commons';

import { TemplatePopupComponent } from './template-popup.component';

export enum TemplatesTypes {
    LEGAL = 'legalTerms',
    PRIVACY = 'privacyPolicy',
}

/** This service loads the template specified and opens the popup */
@Injectable({
    providedIn: 'root',
})
export class TemplateService {
    titleTemplate = '';
    contentTemplate = '';

    constructor(
        private http: HttpClient,
        private translationService: TranslationService,
        private popupService: TwcPopupService,
        private uiConfigurationService: UiConfigurationService
    ) {}

    showTemplate(template: string): void {
        this.titleTemplate = template === TemplatesTypes.PRIVACY ? 'FOOTER.PRIVACY_STATEMENT' : 'FOOTER.TERMS';

        const legalObj = this.uiConfigurationService.getLegal() as any;
        const templateObj = legalObj?.[template];
        const currentLanguage = this.translationService.currentLang.substring(0, 2) as keyof UiConfigurationLanguageGroup;
        const url = templateObj[currentLanguage];

        if (templateObj.modal) {
            this.http.get(url, { responseType: 'text' }).subscribe((t) => {
                this.contentTemplate = t;
                this.popupService.open(TemplatePopupComponent, {});
            });
        } else {
            window.open(url, '_blank');
        }
    }
}
